/** @jsx jsx */
import React, { useState, useEffect } from "react"
import { jsx } from "theme-ui"
import { connect } from "react-redux"
import Layout from "@components/Layouts"

// Components
import SEO from "@components/seo"
import CTAHeadingBlock from "@components/CTAHeadingBlock"
import TwoColumnSection, {
  Block as ColumnBlock,
  ImageBlock as ColumnImageBlock,
} from "@components/TwoColumnSection"
import IconThreeUp from "@components/IconThreeUp"
import AccordionWithBanner from "@components/Accordion/WithBanner"
import ProductsCollection from "@shop/components/ProductsCollection/ProductsCollection"

const PRODUCT_TYPES = [
  { label: "Badges + Pins", value: "badges + pins" },
  { label: "Wearables", value: "wearables" },
  { label: "Stickers", value: "stickers" },
  { label: "Flags", value: "flags" },
  { label: "Booklets + Info", value: "booklets + info" },
  { label: "Events", value: "events" },
  { label: "Posters", value: "posters" },
  { label: "Bundles", value: "bundles" },
  { label: "Popular", value: "popular" },
  // { label: "wear-it-purple", hidden: true },
  // { label: "trans-awareness-week", hidden: true },
  // { label: "IDAHOBIT", hidden: true },
  // { label: "rainbow", hidden: true },
  // { label: "lesbian", hidden: true },
  // { label: "bisexual", hidden: true },
  // { label: "pansexual", hidden: true },
  // { label: "asexual", hidden: true },
  // { label: "aromantic", hidden: true },
  // { label: "non-binary", hidden: true },
  // { label: "trans", hidden: true },
  // { label: "intersex", hidden: true },
  // { label: "QTIPOC", hidden: true },
  { label: "Stationery + Cards", value: "stationery + cards" },
]

const FLAG_TYPES = [
  { label: "Rainbow", value: "rainbow", icon: "flag-rainbow" },
  { label: "Rainbow POC", value: "rainbow POC", icon: "flag-rainbow-poc" },
  { label: "Progress", value: "progress", icon: "flag-progress" },
  {
    label: "Progress Intersex",
    value: "progress-intersex",
    icon: "flag-progress-intersex",
  },
  { label: "Asexual", value: "asexual", icon: "flag-asexual" },
  { label: "Aromantic", value: "aromantic", icon: "flag-aromantic" },
  { label: "Bisexual", value: "bisexual", icon: "flag-bisexual" },
  {
    label: "Gay (MLM)",
    value: "mlm",
    icon: "flag-gay-mlm",
  },
  { label: "Intersex", value: "intersex", icon: "flag-intersex" },
  { label: "Lesbian", value: "lesbian", icon: "flag-lesbian" },
  { label: "Non-binary", value: "non-binary", icon: "flag-nonbinary" },
  { label: "Pansexual", value: "pansexual", icon: "flag-pansexual" },
  { label: "Trans", value: "trans", icon: "flag-trans" },
]

const AUDIENCE_TYPES = [
  {
    label: "All",
    value: "pride",
  },
  {
    label: "Workplaces",
    value: "workplace",
  },
  {
    label: "Schools",
    value: "school",
  },
]

const ShopContainer = ({
  data,
  pageContent = {
    heading: "",
    image: "",
    pillHeading: "",
    pageTitle: "",
    pageDescription: "",
  },
  pathname,
  ...props
}) => {

  const getInitialParams = () => {
    let initialParams = {
      audience: "pride",
      types: [],
      flags: [],
    }

    const urlParts = pathname.split("/")
    // Handle trailing slash
    const lastUrlSegment = urlParts.pop() || urlParts.pop()
    initialParams.audience =
      lastUrlSegment === "shop" ? "pride" : lastUrlSegment

    if (!props.location.href) {
      return initialParams
    }

    const url = new URL(props.location.href)
    const params = new URLSearchParams(url.search)

    const typeParams = params.get("type")
      ? encodeURIComponent(params.get("type"))
        .replace(/%20/g, "+") // Replace spaces with +
        .split(/(\+)/)
        .join(" ")
        .split("%2C") // Split params by comma
      : []

    const flagParams = params.get("flag")
      ? encodeURIComponent(params.get("flag"))
        .replace(/%20/g, "+") // Replace spaces with +
        .split(/(\+)/)
        .join(" ")
        .split("%2C") // Split params by comma
      : []

    initialParams.types = typeParams.filter(Boolean)
    initialParams.flags = flagParams.filter(Boolean)

    return initialParams
  }

  const initialParams = getInitialParams()

  return (
    <>
      <SEO
        title={pageContent.pageTitle}
        image={pageContent.image}
        description={pageContent.pageDescription}
        pathname={props.pathname}
      />
      <TwoColumnSection
        col1={
          <ColumnBlock
            styles={{
              bg: props.headerBg,
              color: props.headerColor,
            }}
          >
            <CTAHeadingBlock
              heading={pageContent.heading}
              body={pageContent.headerText}
            />
          </ColumnBlock>
        }
        col2={<ColumnImageBlock image={pageContent.image} />}
      />
      <IconThreeUp
        textBlocks={[
          "Free shipping for orders $75 and over.",
          "20% off when you order $200 or more.*",
          "100% of profits support LGBTQIA+ youth around Australia.",
        ]}
      />

      <div sx={{ bg: "pink" }}>
        <ProductsCollection
          products={data}
          productTypes={PRODUCT_TYPES}
          flagTypes={FLAG_TYPES}
          audienceTypes={AUDIENCE_TYPES}
          maxItems={18}
          initialParams={initialParams}
          location={props.location}
        />

        {data.og.frontmatter.accordion ? (
          <AccordionWithBanner
            items={data.og.frontmatter.accordion}
            title="More Information"
            noMaxWidthBanner
          />
        ) : null}
      </div>
      {data.og.frontmatter.footerImg ? (
        <img
          src={data.og.frontmatter.footerImg}
          sx={{
            width: "100%",
            display: "block",
          }}
        />
      ) : null}
    </>
  )
}

export default connect(
  state => ({
    checkout: state.cart.checkout,
  }),
  dispatch => ({
    openCartModal: () => dispatch.cartModal.toggleCartModal(true),
  })
)(ShopContainer)
